<template>
  <i>
    <v-alert type="warning">
      {{ notSupportedHeader }}
      <v-row dense>
        <v-col cols="12" md="3">
          <b> {{ $t("userInterface.version.ccu") }}</b>
        </v-col>
        <v-col cols="auto" offset="2" offset-md="0">
          {{ $t("userInterface.version.requiredVersion") }} <b>{{ ccuRequiredVersion }}+</b>
        </v-col>
        <v-col cols="auto" offset="2" offset-md="0">
          {{ $t("userInterface.version.currentVersion") }} <b>{{ ccuCurrentVersion }}</b>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="3">
          <b> {{ $t("userInterface.version.inverter") }}</b>
        </v-col>
        <v-col cols="auto" offset="2" offset-md="0">
          {{ $t("userInterface.version.requiredVersion") }} <b>{{ inverterRequiredVersion }}+</b>
        </v-col>
        <v-col cols="auto" offset="2" offset-md="0">
          {{ $t("userInterface.version.currentVersion") }} <b>{{ inverterCurrentVersion }}</b>
        </v-col>
      </v-row>
      <template v-if="batteryCurrentVersion != '' || batteryRequiredVersion != ''">
        <v-row dense>
          <v-col cols="12" md="3">
            <b> {{ $t("userInterface.version.battery") }}</b>
          </v-col>
          <v-col cols="auto" offset="2" offset-md="0">
            {{ $t("userInterface.version.requiredVersion") }} <b>{{ batteryRequiredVersion }}+</b>
          </v-col>
          <v-col cols="auto" offset="2" offset-md="0">
            {{ $t("userInterface.version.currentVersion") }} <b>{{ batteryCurrentVersion }}</b>
          </v-col>
        </v-row>
      </template>
    </v-alert>
  </i>
</template>

<script>
  export default {
    name: "Components_Alert_AlertVersion",
    props: {
      notSupportedHeader: {
        type: String,
        require: false,
        default: "",
      },
      ccuRequiredVersion: {
        type: String,
        require: false,
        default: "",
      },
      ccuCurrentVersion: {
        type: String,
        require: false,
        default: "",
      },
      inverterRequiredVersion: {
        type: String,
        require: false,
        default: "",
      },
      inverterCurrentVersion: {
        type: String,
        require: false,
        default: "",
      },
      batteryRequiredVersion: {
        type: String,
        require: false,
        default: "",
      },
      batteryCurrentVersion: {
        type: String,
        require: false,
        default: "",
      },
    },
  };
</script>

<style scoped></style>
